export default __webpack_public_path__ + "static/cotes-qui-changent-84817abb1eb14bc6f2403f1e65ee4760.jpg";